<template>
  <div class="archive-preview">
    <preview v-bind="previewData" />
  </div>
</template>

<script>
import Preview from '@/components/Preview.vue';

export default {
  name: 'ArchivePreview',
  components: {
    Preview,
  },
  data() {
    return {
      previewData: {
        src: '/images/preview_archive.png',
        title: 'Archive',
        description: 'Browse through all published strips',
        link: {
          name: 'Archive',
        },
      },
    };
  },
};
</script>
